import AppPeoplecourseweekregistrationsIndex from "./peopleCourseWeekRegistration.vue";
import AppPeoplecourseweekregistrationsList from "./list/list.vue";
import AppPeoplecourseweekregistrationsItem from "./item/item.vue";

const routes = [
  {
    path: "peopleCourseWeekRegistration",
    component: AppPeoplecourseweekregistrationsIndex,
    meta: {
      auth: {
        roles: "peopleCourseWeekRegistration.index",
        redirect: { name: "auth.login" },
        forbiddenRedirect: "/403"
      }
    },
    children: [
      {
        path: "",
        name: "peopleCourseWeekRegistration.index",
        component: AppPeoplecourseweekregistrationsList,
        meta: {
          auth: {
            roles: "peopleCourseWeekRegistration.index",
            redirect: { name: "auth.login" }
          }
        }
      },
      {
        path: "create",
        name: "peopleCourseWeekRegistration.create",
        component: AppPeoplecourseweekregistrationsItem,
        meta: {
          auth: {
            roles: "peopleCourseWeekRegistration.create",
            redirect: { name: "peopleCourseWeekRegistration.index" }
          }
        }
      },
      {
        path: ":id",
        name: "peopleCourseWeekRegistration.edit",
        component: AppPeoplecourseweekregistrationsItem,
        meta: {
          auth: {
            roles: "peopleCourseWeekRegistration.update",
            redirect: { name: "peopleCourseWeekRegistration.index" }
          }
        }
      }
    ]
  }
];

export default routes;
